function copyObjectProps(objFrom, objTo) {
    for(var i in objFrom) {
        if(!objFrom.hasOwnProperty(i)) continue;

        if(Array.isArray(objFrom[i])) {
            objTo[i] = [];
            for(var n=0; n<objFrom[i].length; n++) {
                if(typeof objFrom[i][n] == "object" && objFrom[i][n] !== null) {
                    objTo[i][n] = cloneEmptyObject(objFrom[i][n]);
                    copyObjectProps(objFrom[i][n], objTo[i][n]);
                }
                else objTo[i][n] = objFrom[i][n];
            }
            continue;
        }

        if(isPlainObject(objFrom[i])) {
            objTo[i] = {};
            copyObjectProps(objFrom[i], objTo[i]);
            continue;
        }

        objTo[i] = objFrom[i];
    }
}

function cloneEmptyObject(obj) {
    if(obj.constructor) return new obj.constructor();
    return {};
}

function isPlainObject(obj) {
    if(!obj || !obj.constructor) return false;
    return obj.constructor === Object;
}

/**
 * Набор утилитарных функций
 */
export class Utils {

    /**
     * @description Парсинг GET-параметров страницы
     * @returns {Object} ассоциативный массив ключ-значение
     */
    static parseGet() {

        var get = {};

        var s = window.location.search.length && window.location.search.substr(1).split('&') || [];
        for (let param of s) {
            let [key, ...value] = param.split('=');
            get[key] = value.join('=');
        }
        return get;
    }

    /**
     * @description Привязка функции к контексту.
     * @param {Function} fn
     * @param {Object} context
     * @param {...*} proxyArgs
     */
    static proxy(fn, context, ...proxyArgs) {
        return function (...args) {
            return fn.apply(context || this, args.concat(proxyArgs));
        };
    }

    /**
     * Клонирование
     * @param {mixed} obj
     */
    static clone(obj) {
        if(!obj || (typeof obj != "object")) return obj;

        var clone = cloneEmptyObject(obj);
        copyObjectProps(obj, clone);

        return clone;
    }
    
    static shuffleArray(arr) {
        let cnt = arr.length;

        while (cnt > 0) {
            let ix = Math.floor(Math.random() * cnt);
            cnt--;
            let temp = arr[cnt];
            arr[cnt] = arr[ix];
            arr[ix] = temp;
        }

        return arr;
    }

    /** Прерывание события */
    static preventInteractiveEvent(e) {
        if(e && e.stopPropagation) e.stopPropagation();
        return false;
    }
}

